import { createRouter } from "@acme/shared/create-router";
import { sentryEnvironment } from "@acme/shared/sentry-environment";
import { deLocalizeUrl, localizeUrl } from "./paraglide/runtime.js";
import { routeTree } from "./routeTree.gen";

export function getRouter() {
  return createRouter<typeof routeTree>({
    rewrite: {
      input: ({ url }) => deLocalizeUrl(url),
      output: ({ url }) => localizeUrl(url),
    },
    routeTree,
    sentryEnvironment: sentryEnvironment(
      import.meta.env.VITE_VERCEL_ENV,
      import.meta.env.MODE
    ),
  });
}
